import { render } from "./ReleaseNotes.vue?vue&type=template&id=d0edf8f6&scoped=true&ts=true"
import script from "./ReleaseNotes.vue?vue&type=script&lang=ts"
export * from "./ReleaseNotes.vue?vue&type=script&lang=ts"

import "./ReleaseNotes.vue?vue&type=style&index=0&id=d0edf8f6&lang=scss&scoped=true"
import "./ReleaseNotes.vue?vue&type=style&index=1&id=d0edf8f6&lang=scss"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0edf8f6"]])

export default __exports__